var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navbar"}},[(!_vm.storeMode)?_c('JewelerAiBanner'):_vm._e(),_c('navbar-top'),(!_vm.storeMode || _vm.isDiamondsPage)?_c('navbar-bottom'):_vm._e(),_c('navbar-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }